var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02416 2.44872C9.06072 2.31914 9.1366 2.20539 9.24043 2.12449C9.34427 2.0436 9.47046 1.99992 9.60012 2H14.3998C14.4948 2.00008 14.5885 2.02366 14.673 2.0688C14.7576 2.11395 14.8306 2.17937 14.8862 2.25967C14.9417 2.33998 14.9781 2.43288 14.9925 2.53072C15.0068 2.62856 14.9986 2.72855 14.9686 2.82245L12.8327 9.49955H17.3996C17.512 9.49947 17.6221 9.53226 17.7174 9.59417C17.8128 9.65609 17.8895 9.74465 17.9389 9.84976C17.9883 9.95488 18.0084 10.0723 17.9968 10.1888C17.9853 10.3052 17.9426 10.4159 17.8736 10.5082L9.47413 21.7576C9.38808 21.8734 9.26573 21.954 9.12843 21.9854C8.99113 22.0169 8.8476 21.9971 8.72288 21.9295C8.59816 21.8619 8.50017 21.7509 8.44602 21.6158C8.39188 21.4806 8.385 21.33 8.4266 21.1901L10.5877 13.8743H6.60031C6.50704 13.8744 6.41503 13.8518 6.33161 13.8083C6.24818 13.7648 6.17563 13.7017 6.11972 13.6239C6.06381 13.5462 6.02608 13.4559 6.00953 13.3603C5.99297 13.2646 5.99805 13.1663 6.02435 13.0731L9.02416 2.44872Z",
    fill: "#323C47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.d476c51e.svg";
export { ForwardRef as ReactComponent };